module.exports = __webpack_public_path__ + "static/media/favicon.2c11a32a.png";